module.exports = __webpack_public_path__ + "08_face.a98216f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer1/08_face.png
// module id = ht52
// module chunks = 0